module.exports = __webpack_public_path__ + "img/image_charactor.d337db5a.png";